import { render, staticRenderFns } from "./receive-coupon.vue?vue&type=template&id=4f4d6ea9&scoped=true&"
import script from "./receive-coupon.vue?vue&type=script&lang=js&"
export * from "./receive-coupon.vue?vue&type=script&lang=js&"
import style0 from "./receive-coupon.vue?vue&type=style&index=0&id=4f4d6ea9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d6ea9",
  null
  
)

export default component.exports